import React from 'react';
import ManageQuickLinks from '../ManageQuickLinks/ManageQuickLinks';

const ManageUI2MenuLinks = () => {
  return <ManageQuickLinks locationLinksOnly={true} />;
};

export default ManageUI2MenuLinks;
